module.exports = __webpack_public_path__ + "static/img/mobile_home.471e039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_home.png
// module id = PxDa
// module chunks = 1